/*
 * Copyright (c) 2025 Étienne FOLIO
 * Tous droits réservés.
 *
 * Ce fichier fait partie d'un logiciel propriétaire.
 * Toute reproduction, modification ou distribution, totale ou partielle,
 * de ce fichier est interdite sans l'autorisation écrite préalable
 * de l'auteur.
 */

const baseLists = {
  pad:               { path: '/pad',               label: 'PAD',               showBadge: true },
  captation:         { path: '/captation',         label: 'Captation',         showBadge: true },
  contact:           { path: '/contact',           label: 'Contact',           showBadge: true },
  structure:         { path: '/structure',         label: 'Structure',         showBadge: true },
  serie:             { path: '/serie',             label: 'Série',             showBadge: true },
  action:            { path: '/action',            label: 'Action',            showBadge: true },
  service_radio:     { path: '/service_radio',     label: 'Service Radio',     showBadge: true },
  association:       { path: '/association',       label: 'Association',       showBadge: true },
  type_de_pad:       { path: '/type_de_pad',       label: 'Type de PAD',       showBadge: true },
  type_de_captation: { path: '/type_de_captation', label: 'Type de captation', showBadge: true },
  type_de_serie:     { path: '/type_de_serie',     label: 'Type de série',     showBadge: true },
  type_action:       { path: '/type_action',       label: "Type d'action",     showBadge: true },
  document_emargement:{ path: '/document_emargement', label: "Document d'émargement", showBadge: true },
  document_serie:    { path: '/document_serie',    label: 'Document Série',    showBadge: true },
  document_action:   { path: '/document_action',   label: 'Document Action',   showBadge: true },
  periodicite:       { path: '/periodicite',       label: 'Périodicité',       showBadge: true },
  article_du_nom:    { path: '/article_du_nom',    label: 'Article du nom',    showBadge: true },
  critere:           { path: '/critere',           label: 'Critère',           showBadge: true },
  critere_fser:      { path: '/critere_fser',      label: 'Critère FSER',      showBadge: true },
};

export default baseLists;
